import { CommunityMember, CommunityMemberFormData } from 'domain/Community';

export const mapMemberToApi = (
  currentMemberData: CommunityMember | undefined,
  data: Partial<CommunityMemberFormData>
): Partial<CommunityMember> => ({
  role: data.role ?? currentMemberData?.role,
});
